(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dastaan-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dastaan-card-gallery')) {
  customElements.define('dastaan-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.dst-gallery-track');
      const previous = this.querySelector('.dst-gallery-prev');
      const next = this.querySelector('.dst-gallery-next');
      const count = this.querySelector('.dst-gallery-count');
      if (!previous || !next) return;
      const update = () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        previous.disabled = index === 0;
        next.disabled = index >= track.children.length - 1;
        count.textContent = `${index + 1} / ${track.children.length}`;
      };
      const move = direction => track.scrollTo({left: (Math.round(track.scrollLeft / track.clientWidth) + direction) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      update();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
